import { headerStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsHeader";
import { css } from "styled-components";

headerStyles.saveButton = {
    mergeCss: true,
    css: css`
        margin-left: 10px;
    `,
};

headerStyles.menuHidden = {
    above: "sm",
    css: css`
        margin-left: 20px;
        max-width: initial;
        button {
            min-width: 100%;
            &:hover {
                border: none !important;
                background: none !important;
            }
            &:focus {
                outline: none !important;
            }
        }
    `,
};

headerStyles.buttonSet = {
    css: css`
        justify-content: flex-end;
    `,
    width: [1, 1, 5, 4, 3],
};

headerStyles.titleWrapper = {
    width: [11, 11, 7, 8, 9],
};

headerStyles.title = {
    variant: "h2",
};
